<template>
  <div class="admin">
    <hr>
    <h2 class="is-size-2">Admin Tools</h2>
    <div class="columns">
      <div
        v-if="profile && profile.super"
        class="column">
        <div
          class="message is-info">
          <h4 class="message-header">Add Family Member</h4>
          <div class="message-body">
            <div class="field">
              <label
                class="label"
                for="member-id">Auth0 ID</label>
              <input
                v-model="newMember.id"
                type="text"
                name="member-id"
                class="form-text input" />
            </div>
            <div class="field">
              <label
                class="label"
                for="member-name">Name</label>
              <input
                v-model="newMember.name"
                type="text"
                name="member-name"
                class="form-text input" />
            </div>
            <div class="field">
              <label
                class="label"
                for="member-family">Family</label>
              <input
                v-model="newMember.family"
                type="text"
                name="member-family"
                class="form-text input" />
            </div>
            <div class="buttons">
              <button
                class="button"
                @click="addNewMember">Add New Member</button>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="message is-primary">
          <h4 class="message-header">{{ lastMatch }} Order</h4>
          <div class="message-body">
            <div
              v-for="(match, i) in matches"
              :key="match.giver.id"
              class="match-row">
              {{ i + 1}})
              <strong>{{ match.giver.name }}</strong>
              <em> gives to </em>
              <strong>
                <a href="#" @click.prevent="showProfile(match.recipient)">{{ match.recipient.name }}</a>
              </strong>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="currentYear != lastMatch"
        class="column">
        <div class="message">
          <h4 class="message-header">Create New Order</h4>
          <div class="message-body">
            <p>Click the button to generate a new order.
              If you're not happy with the order, click the button again.
              When you're satisfied with the order, click the "Save New Order" button.
            </p>
            <p
              v-if="matchError"
              class="notification is-danger">
              An error occorred while creating the new match order.
              Please click the button to try again.
            </p>
            <div v-if="newMatches && newMatches.length">
              <div
                v-for="match in newMatches"
                :key="match.giver.id"
                class="match-row">
                <strong>{{ match.giver.name }}</strong>
                <em> gives to </em>
                <strong>{{ match.recipient.name }}</strong>
              </div>
            </div>
            <div
              class="buttons">
              <button
                :disabled="saving"
                class="button is-info"
                @click="generateNewMatch">Generate New Order</button>
              <button
                :disabled="saving"
                :class="{'is-loading': saving}"
                class="button is-primary"
                @click="saveNewMatch">Save New Order</button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="column">
        You have already set the match order for {{ currentYear }}.
        Please contact Beejay if you need to reset the match.
        <p class="notification is-primary">Click a name in the list to the left to view that user's profile.</p>
        <profile
          v-if="showing"
          :profile="showing" />
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import api from '@/services/api'
import matchmaker from '@/services/matchmaker'
import Profile from './Profile'

export default {
  name: 'Admin',
  components: { Profile },
  props: {
    profile: {
      type: Object,
      validator (val) {
        return val.id
      },
      required: true
    }
  },
  data () {
    return {
      matches: {},
      lastMatch: null,
      currentYear: new Date().getFullYear(),
      newMatches: {},
      matchError: false,
      newMember: {},
      saving: false,
      showing: null
    }
  },
  computed: {
    list () {
      return this.matches.map(m => m.giver)
    },
    matchHash () {
      let hash = {}
      this.matches.forEach(m => {
        hash[m.giver.id] = m.recipient.id
      })
      return hash
    }
  },
  created () {
    this.getMatches()
    this.getLastMatch()
  },
  methods: {
    getMatches () {
      api.get('/matches').then(({ data }) => {
        this.matches = data
      })
    },
    getLastMatch () {
      api.get('/last-match').then(({ data }) => {
        this.lastMatch = data.date
      })
    },
    generateNewMatch () {
      this.matchError = false
      const match = matchmaker(this.list, this.matchHash)
      if (!match) {
        this.matchError = true
        return
      }
      this.newMatches = match
    },
    saveNewMatch () {
      this.saving = true
      api.put('/matches', { matches: this.newMatches })
        .then(() => {
          this.saving = false
          this.newMatches = {}
          this.getMatches()
        })
        .catch((err) => {
          const resp = err.response.data
          console.log(resp.error)
          this.saving = false
          const msg = resp.error || 'Error. Please try again.'
          alert(msg)
        })
    },
    addNewMember () {
      const m = this.newMember
      if (!m.id || !m.name || !m.family) { return }
      this.saving = true
      api.post('/member', { member: this.newMember })
        .then(() => {
          this.saving = false
          this.newMember = {}
          this.getMatches()
        })
        .catch(() => {
          this.saving = false
        })
    },
    showProfile (profile) {
      this.showing = null
      setTimeout(() => {
        this.showing = profile
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.admin {
  margin-top: 40px;
}
.match-row {
  border-bottom: 1px solid #CCC;
  &:last-of-type {
    border: 0;
  }
  padding: 10px 0;
  em {
    margin: 0 10px;
  }
}
</style>
